import React from "react";
import AccountBalanceRoundedIcon from "@mui/icons-material/AccountBalanceRounded";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import AccountTreeRoundedIcon from "@mui/icons-material/AccountTreeRounded";
import AdminPanelSettingsRoundedIcon from "@mui/icons-material/AdminPanelSettingsRounded";
import AnalyticsRoundedIcon from "@mui/icons-material/AnalyticsRounded";
import CategoryRoundedIcon from "@mui/icons-material/CategoryRounded";
import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
import EventAvailableRoundedIcon from "@mui/icons-material/EventAvailableRounded";
import GroupsRoundedIcon from "@mui/icons-material/GroupsRounded";
import HistoryRoundedIcon from "@mui/icons-material/HistoryRounded";
import Inventory2RoundedIcon from "@mui/icons-material/Inventory2Rounded";
import InventoryRoundedIcon from "@mui/icons-material/InventoryRounded";
import ListAltRoundedIcon from "@mui/icons-material/ListAltRounded";
import LockResetRoundedIcon from "@mui/icons-material/LockResetRounded";
import ManageAccountsRoundedIcon from "@mui/icons-material/ManageAccountsRounded";
import NotificationsActiveRoundedIcon from "@mui/icons-material/NotificationsActiveRounded";
import PaymentsRoundedIcon from "@mui/icons-material/PaymentsRounded";
import PeopleAltRoundedIcon from "@mui/icons-material/PeopleAltRounded";
import PercentRoundedIcon from "@mui/icons-material/PercentRounded";
import PointOfSaleRoundedIcon from "@mui/icons-material/PointOfSaleRounded";
import PublicRoundedIcon from "@mui/icons-material/PublicRounded";
import ReceiptLongRoundedIcon from "@mui/icons-material/ReceiptLongRounded";
import RestaurantRoundedIcon from "@mui/icons-material/RestaurantRounded";
import RestaurantMenuRoundedIcon from "@mui/icons-material/RestaurantMenuRounded";
import SoupKitchenRoundedIcon from "@mui/icons-material/SoupKitchenRounded";
import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded";
import ShareRoundedIcon from "@mui/icons-material/ShareRounded";
import SpaceDashboardRoundedIcon from "@mui/icons-material/SpaceDashboardRounded";
import StorefrontRoundedIcon from "@mui/icons-material/StorefrontRounded";
import SwapHorizRoundedIcon from "@mui/icons-material/SwapHorizRounded";
import TableRestaurantRoundedIcon from "@mui/icons-material/TableRestaurantRounded";
import EventSeatRoundedIcon from "@mui/icons-material/EventSeatRounded";
import MenuBookRoundedIcon from "@mui/icons-material/MenuBookRounded";
import MoreHorizRoundedIcon from "@mui/icons-material/MoreHorizRounded";
import WarehouseRoundedIcon from "@mui/icons-material/WarehouseRounded";
import WorkspacePremiumRoundedIcon from "@mui/icons-material/WorkspacePremiumRounded";

const ICONS = Object.freeze({
  home: DashboardRoundedIcon,
  page: PublicRoundedIcon,
  products: Inventory2RoundedIcon,
  agenda: EventAvailableRoundedIcon,
  tables: TableRestaurantRoundedIcon,
  restaurant: RestaurantRoundedIcon,
  "restaurant-menu": RestaurantMenuRoundedIcon,
  reservations: EventSeatRoundedIcon,
  kitchen: SoupKitchenRoundedIcon,
  recipes: MenuBookRoundedIcon,
  orders: ListAltRoundedIcon,
  customers: GroupsRoundedIcon,
  management: WarehouseRoundedIcon,
  stats: AnalyticsRoundedIcon,
  settings: SettingsRoundedIcon,
  more: MoreHorizRoundedIcon,
  account: AccountCircleRoundedIcon,
  activity: HistoryRoundedIcon,
  superpanel: AdminPanelSettingsRoundedIcon,
  users: PeopleAltRoundedIcon,
  billing: WorkspacePremiumRoundedIcon,
  projects: StorefrontRoundedIcon,
  referrals: ShareRoundedIcon,
  security: LockResetRoundedIcon,
  payments: PaymentsRoundedIcon,
  notifications: NotificationsActiveRoundedIcon,
  permissions: ManageAccountsRoundedIcon,
  "management-overview": SpaceDashboardRoundedIcon,
  "management-items": CategoryRoundedIcon,
  "management-movements": ReceiptLongRoundedIcon,
  "management-cash": PointOfSaleRoundedIcon,
  "management-stock": InventoryRoundedIcon,
  "management-accounting": AccountBalanceRoundedIcon,
  "management-transactions": SwapHorizRoundedIcon,
  "management-accounts": AccountTreeRoundedIcon,
  "management-taxes": PercentRoundedIcon,
});

export function getDashboardNavigationIcon(name) {
  return ICONS[name] || SettingsRoundedIcon;
}

export default function DashboardNavigationIcon({ name, ...props }) {
  const Icon = getDashboardNavigationIcon(name);
  return <Icon {...props} />;
}
